/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-13 19:42:18
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-04-20 17:06:43
 * @name: 品牌系列型号对象
 * @Description: 品牌系列型号对象
 * @FilePath: \preSaleNafterSaleBackstage\src\object\goods\modelGoods.class.js
 * @Author: DESKTOP-1QU67QM
 */
import { categoryGetAllThirdlevelList, categoryGetList, categoryAdd, categoryEdit, categoryDelete, categoryChangeStatus } from "@/api/goodsManage/goods.api.js";
import { apiMethod } from "@/utils/decorator.js";

const modelGoods = class modelGoods {
  constructor() {
    this.table_brand_data = { total: 0, list: [] }; //品牌表格 -> {total{Number}: 表格数据总量, list{Array}: 表格当前展示数组}
    this.table_series_data = { id: 0, category_name: '', total: 0, list: [] }; //系列表格 -> {id{Number}: 所属品牌id,category_name{String}: 所属品牌名称,total{Number}: 表格数据总量, list{Array}: 表格当前展示数组}
    this.table_model_data = { id: 0, category_name: '', total: 0, list: [] }; //型号表格 -> {id{Number}: 所属系列id,category_name{String}: 所属系列名称,total{Number}: 表格数据总量, list{Array}: 表格当前展示数组}
    this.options_brand = []; //品牌选择框数组
    this.options_series = []; //系列选择框数组
    this.options_model = []; //型号选择框数组
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取品牌表格数据
   */
  @apiMethod(categoryGetList)
  async getTableBrandData(res) {
    if (res.code === 200) {
      this.table_brand_data.total = res.data.total;
      this.table_brand_data.list = res.data.data.map(x => {
        x.level_name = '品牌';
        return x;
      });
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取系列表格数据
   */
  @apiMethod(categoryGetList)
  async getTableSeriesData(res) {
    if (res.code === 200) {
      this.table_series_data.total = res.data.total;
      this.table_series_data.list = res.data.data.map(x => {
        x.level_name = '系列';
        return x;
      });
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取型号表格数据
   */
  @apiMethod(categoryGetList)
  async getTableModelData(res) {
    if (res.code === 200) {
      this.table_model_data.total = res.data.total;
      this.table_model_data.list = res.data.data.map(x => {
        x.level_name = '型号';
        return x;
      });
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加品牌
   */
  @apiMethod(categoryAdd)
  async addBrand(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 编辑品牌
   */
  @apiMethod(categoryEdit)
  async editBrand(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除品牌
   */
  @apiMethod(categoryDelete)
  async delBrand(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加系列
   */
  @apiMethod(categoryAdd)
  async addSeries(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 编辑系列
   */
  @apiMethod(categoryEdit)
  async editSeries(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除系列
   */
  @apiMethod(categoryDelete)
  async delSeries(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 添加型号
   */
  @apiMethod(categoryAdd)
  async addModel(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 编辑型号
   */
  @apiMethod(categoryEdit)
  async editModel(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 删除型号
   */
  @apiMethod(categoryDelete)
  async delModel(res) { }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 变化品牌表格中品牌的状态
   */
  @apiMethod(categoryChangeStatus)
  async brandStatusChange(res, params) {
    if (res.code === 200) {
      this.table_brand_data.list[
        this.table_brand_data.list.findIndex((x) => x.id === params.category_id)
      ].status = params.status;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 变化系列表格中系列的状态
   */
  @apiMethod(categoryChangeStatus)
  async seriesStatusChange(res, params) {
    if (res.code === 200) {
      this.table_series_data.list[
        this.table_series_data.list.findIndex((x) => x.id === params.category_id)
      ].status = params.status;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 变化型号表格中型号的状态
   */
  @apiMethod(categoryChangeStatus)
  async modelStatusChange(res, params) {
    if (res.code === 200) {
      this.table_model_data.list[
        this.table_model_data.list.findIndex((x) => x.id === params.category_id)
      ].status = params.status;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取品牌选择框数组
   */
  @apiMethod(categoryGetList)
  async getOptionsBrand(res) {
    if (res.code === 200) {
      this.options_brand = res.data.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取系列选择框数组
   * @param {Number} id 品牌id
   */
  @apiMethod(categoryGetList)
  async getOptionsSeriesByBrand(res) {
    if (res.code === 200) {
      this.options_series = res.data.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取型号选择框数组
   */
  @apiMethod(categoryGetList)
  async getOptionsModelBySeries(res) {
    if (res.code === 200) {
      this.options_model = res.data.data;
    }
  }
  /**
   * @Auther: 罗耀祖
   * @LastEditors: 罗耀祖
   * @description: 获取型号选择框数组
   */
  @apiMethod(categoryGetAllThirdlevelList)
  async getOptionsModel(res) {
    if (res.code === 200) {
      this.options_model = res.data;
    }
  }
}
export default modelGoods;
